export default __webpack_public_path__ + "static/media/facebook.43a969b5.svg";